import { render, staticRenderFns } from "./ImageGroup.vue?vue&type=template&id=32f298fd&"
import script from "./ImageGroup.vue?vue&type=script&lang=js&"
export * from "./ImageGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports